/** CDN hostname -> backend URL mapping for self-mounted IIFE embeds. */
export const BACKEND_BY_CDN_HOST: Record<string, string> = {
  "super-phoebe.sandbox.uopx.io": "https://phoebe-2.knowledge-domain.sandbox.uopx.io:8003",
  "phoebe-stage.phoenix.edu": "https://phoebe-2.st.uopx.io:8003",
  "phoebe.phoenix.edu": "https://phoebe-2.uopx.io:8003",
};

/**
 * CDN hosts that serve non-production embeds. Browser QA utilities default on
 * for these and stay off everywhere else, including phoebe.phoenix.edu.
 */
const NONPROD_CDN_HOSTS = new Set(["super-phoebe.sandbox.uopx.io", "phoebe-stage.phoenix.edu"]);

/** Backend origins whose deployed task config exposes /v1/auth/guest-session. */
const GUEST_BOOTSTRAP_BACKEND_ORIGINS = new Set([
  "https://phoebe-2.knowledge-domain.sandbox.uopx.io:8003",
  "https://phoebe-2.st.uopx.io:8003",
  "https://phoebe-2.uopx.io:8003",
]);

export function inferBackendUrlFromScriptSrc(scriptSrc: string | null | undefined): string | undefined {
  if (!scriptSrc) return undefined;
  try {
    const host = new URL(scriptSrc).hostname;
    return BACKEND_BY_CDN_HOST[host];
  } catch {
    return undefined;
  }
}

export function resolveBackendUrl(
  configuredBackendUrl: string | null | undefined,
  scriptSrc: string | null | undefined,
): string | undefined {
  return configuredBackendUrl ?? inferBackendUrlFromScriptSrc(scriptSrc);
}

export function isNonProdCdnScriptSrc(scriptSrc: string | null | undefined): boolean {
  if (!scriptSrc) return false;
  try {
    return NONPROD_CDN_HOSTS.has(new URL(scriptSrc).hostname);
  } catch {
    return false;
  }
}

export function shouldAutoEnableGuestBootstrap(backendUrl: string | null | undefined): boolean {
  if (!backendUrl) return false;
  try {
    return GUEST_BOOTSTRAP_BACKEND_ORIGINS.has(new URL(backendUrl).origin);
  } catch {
    return false;
  }
}
